import { useState } from "react";
import { motion } from "framer-motion";
import { FILTERS, PROJECTS } from "@/data/projects";
import { ProjectCard } from "@/components/ProjectCard";
import { MaskLines, Reveal } from "@/components/Primitives";
import { usePageMeta } from "@/lib/motion";

const slug = (s) => s.toLowerCase().replace(/\s+/g, "-");

const FilterBar = ({ active, onChange }) => (
  <div className="flex flex-wrap gap-x-8 gap-y-4 border-b border-line pb-5" role="tablist" aria-label="Filter projects by category">
    {FILTERS.map((f) => {
      const count = f === "All" ? PROJECTS.length : PROJECTS.filter((p) => p.filters.includes(f)).length;
      const on = active === f;
      return (
        <button
          key={f}
          role="tab"
          aria-selected={on}
          onClick={() => onChange(f)}
          className={`relative pb-2 font-mono text-xs uppercase tracking-[0.2em] transition-colors duration-300 ${on ? "text-ivory" : "text-ash hover:text-ivory"}`}
          data-testid={`project-filter-${slug(f)}`}
        >
          {f} <sup className="text-gold">{count}</sup>
          {on && <motion.span layoutId="filter-underline" className="absolute inset-x-0 -bottom-[21px] h-px bg-gold" />}
        </button>
      );
    })}
  </div>
);

export default function Projects() {
  usePageMeta("Projects — Hades", "The full collection of Hades' websites, software, Discord bots, AI work and experiments.");
  const [active, setActive] = useState("All");
  const list = active === "All" ? PROJECTS : PROJECTS.filter((p) => p.filters.includes(active));
  return (
    <section className="pb-32 pt-40 sm:pt-48" data-testid="projects-page">
      <div className="container-x">
        <Reveal><span className="eyebrow">Index / All Work</span></Reveal>
        <MaskLines as="h1" onLoad delay={0.1} lines={["The Complete", "Collection."]} className="mt-8 font-serif text-6xl font-light leading-[0.95] text-ivory sm:text-7xl lg:text-[8rem]" />
        <Reveal className="mt-16"><FilterBar active={active} onChange={setActive} /></Reveal>
        {list.length ? (
          <div className="mt-16 grid grid-cols-1 gap-x-10 gap-y-20 md:grid-cols-2" data-testid="projects-grid">
            {list.map((p, i) => (
              <ProjectCard key={`${active}-${p.slug}`} project={p} className={i % 2 ? "md:mt-24" : ""} aspect="aspect-[4/3]" />
            ))}
          </div>
        ) : (
          <div className="mt-24 border border-dashed border-line p-16 text-center" data-testid="projects-empty-state">
            <p className="font-serif text-3xl italic text-ivory">Nothing here — yet.</p>
            <p className="mt-3 text-ash">New work in this category is on its way.</p>
          </div>
        )}
      </div>
    </section>
  );
}
